import { render, staticRenderFns } from "./importAllocate.vue?vue&type=template&id=015d28f6&scoped=true&"
import script from "./importAllocate.vue?vue&type=script&lang=js&"
export * from "./importAllocate.vue?vue&type=script&lang=js&"
import style0 from "./importAllocate.vue?vue&type=style&index=0&id=015d28f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d28f6",
  null
  
)

export default component.exports